import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Administradores from '@/components/Administradores'
import Instituicoes from '@/components/Instituicoes'
import Objetivos from '@/components/Objetivos'
import Medidas from '@/components/Medidas'
import Acoes from '@/components/Acoes'
import Dimensoes from '@/components/Dimensoes'
import Perguntas from '@/components/Perguntas'
import Formularios from '@/components/Formularios'
import Setores from '@/components/Setores'
import Propostas from '@/components/Propostas'
import Anos from '@/components/Anos'

Vue.use(Router)
Vue.component('Login', Login);

// -- TABLES
import Table_Administradores from '@/components/tables/Table_Administradores'
import Table_Instituicoes from '@/components/tables/Table_Instituicoes'
import Table_Objetivos from '@/components/tables/Table_Objetivos'
import Table_Medidas from '@/components/tables/Table_Medidas'
import Table_Acoes from '@/components/tables/Table_Acoes'
import Table_Dimensoes from '@/components/tables/Table_Dimensoes'
import Table_Perguntas from '@/components/tables/Table_Perguntas'
import Table_Formularios from '@/components/tables/Table_Formularios'
import Table_Setores from '@/components/tables/Table_Setores'
import Table_Propostas from '@/components/tables/Table_Propostas'
import Table_Anos from '@/components/tables/Table_Anos'
import Table_Fases from '@/components/tables/Table_Fases'
import Table_Propostas_Admin from '@/components/tables/Table_Propostas_Admin'
import Table_Home from '@/components/tables/Table_Home'

import Perfil from '@/components/Perfil'

Vue.component('Table_Administradores', Table_Administradores)
Vue.component('Table_Instituicoes', Table_Instituicoes)
Vue.component('Table_Objetivos', Table_Objetivos)
Vue.component('Table_Medidas', Table_Medidas)
Vue.component('Table_Acoes', Table_Acoes)
Vue.component('Table_Dimensoes', Table_Dimensoes)
Vue.component('Table_Perguntas', Table_Perguntas)
Vue.component('Table_Formularios', Table_Formularios)
Vue.component('Table_Setores', Table_Setores)
Vue.component('Table_Propostas', Table_Propostas)
Vue.component('Table_Anos', Table_Anos)
Vue.component('Table_Fases', Table_Fases)
Vue.component('Table_Propostas_Admin', Table_Propostas_Admin)
Vue.component('Table_Home', Table_Home)
Vue.component('perfil',Perfil)


// -- TABLES


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/administradores',
      name: 'administradores',
      component: Administradores
    },
    {
      path: '/instituicoes',
      name: 'instituicoes',
      component: Instituicoes
    },
    {
      path: '/objetivos',
      name: 'objetivos',
      component: Objetivos
    },
    {
      path: '/medidas',
      name: 'medidas',
      component: Medidas
    },
    {
      path: '/acoes',
      name: 'acoes',
      component: Acoes
    },
    {
      path: '/dimensoes',
      name: 'dimensoes',
      component: Dimensoes
    },
    {
      path: '/perguntas',
      name: 'perguntas',
      component: Perguntas
    },
    {
      path: '/formularios',
      name: 'formularios',
      component: Formularios
    },
    {
      path: '/setores',
      name: 'setores',
      component: Setores
    },
    {
      path: '/propostas',
      name: 'propostas',
      component: Propostas
    },
    {
      path: '/anos',
      name: 'anos',
      component: Anos
    },

    {
      path: '/perfil',
      name: 'perfil',
      component: Perfil
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js